import proj4 from 'proj4';

// Definir sistemas de coordenadas
proj4.defs([
  ['EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs'],
  ['EPSG:25830', '+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'], // ETRS89 UTM 30N
  ['EPSG:25829', '+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'], // ETRS89 UTM 29N
  ['EPSG:25831', '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs']  // ETRS89 UTM 31N
]);

export const getUTMZone = (longitude) => {
  if (longitude >= -6 && longitude < 0) return 29;
  if (longitude >= 0 && longitude < 6) return 30;
  if (longitude >= 6 && longitude < 12) return 31;
  return 30; // Por defecto
};

export const convertCoordinates = (points, fromSystem, toSystem) => {
  try {
    return points.map(point => {
      const [x, y] = proj4(fromSystem, toSystem, [point.x, point.y]);
      return {
        ...point,
        x: parseFloat(x.toFixed(3)),
        y: parseFloat(y.toFixed(3))
      };
    });
  } catch (error) {
    console.error('Error en conversión de coordenadas:', error);
    return points;
  }
};

export const detectCoordinateSystem = (points) => {
  if (points.length === 0) return 'geographic';
  
  const avgX = points.reduce((sum, p) => sum + Math.abs(p.x), 0) / points.length;
  const avgY = points.reduce((sum, p) => sum + Math.abs(p.y), 0) / points.length;
  
  // Si los valores son pequeños (< 180), probablemente son geográficas
  if (avgX <= 180 && avgY <= 90) {
    return 'geographic';
  }
  
  // Si son valores grandes, probablemente UTM
  return 'utm';
};

export const getProjectionString = (zone) => {
  const epsgCodes = {
    29: 'EPSG:25829',
    30: 'EPSG:25830',
    31: 'EPSG:25831'
  };
  return epsgCodes[zone] || 'EPSG:25830';
};